import type { ICustomCategoriesAndShared } from "app/services/category/userCustomCategoryService";

// Action Types
const CUSTOM_CATEGORIES_REQUEST = "CUSTOM_CATEGORIES_REQUEST";
const CUSTOM_CATEGORIES_SUCCESS = "CUSTOM_CATEGORIES_SUCCESS";

// Action Creators
export const requestCustomCategories = () => ({
    type: CUSTOM_CATEGORIES_REQUEST,
});

export const requestCustomCategoriesSuccess = (payload: ICustomCategoriesAndShared) => ({
    type: CUSTOM_CATEGORIES_SUCCESS,
    payload,
});
